import plusnew, { component } from "@plusnew/core";

export default component(__dirname, () => (
  <div>This route has invalid parameters</div>
));
